/* eslint-disable no-unused-vars */
import React, { createContext, useContext, useCallback, useEffect, useRef, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';

import { actions } from '../features/work-history-slice';
import { queryHistoryOrder } from '../features/work-history-thunk';

import { ZetaSection, ZetaGroup } from '../zeta-widget';
import { loadLayout, loadTemplate } from '../tools/layout-tool';
import { loadDataList } from '../tools/option-tool';

// import { PillStatus } from './work-widget';

// import { useAuth } from '../use-auth';
import { useHistory, useParams } from 'react-router-dom';

const defaultEnquiryLayout = [
  {
    name: 'filter',
    file: 'reports/history-filter',
    size: 'full',
    class: '',
  }
];

const foundProductGroup = {
  name: 'found',
  file: 'reports/history-found-product',
  size: 'full',
  class: 'table-responsive-sm',
}

const foundContactGroup = {
  name: 'found',
  file: 'reports/history-found-contact',
  size: 'full',
  class: 'table-responsive-sm',
}

function Pill(props) {
  const { color } = props;
  return (
    <React.Fragment>
      <span className={`badge badge-pill badge-${color}`}>{props.children}</span>
      <br />
    </React.Fragment>
  );
}

function DateSpan(props) {
  const { dateFmt } = props;
  const value = props.children;

  return (
    <React.Fragment>
      {props.label || ''}
      <span>{value && dateFmt.format(new Date(value))}</span>
      <br />
    </React.Fragment>
  );
}

function DateTable(props) {
  const { dateFmt, value } = props;
  const noBottomPadding = {paddingBottom: 0}

  return <table className="table table-sm table-borderless" style={{maxWidth: '160px'}}>
    <tbody>
      <tr>
        <td style={noBottomPadding}>สั่ง : </td>
        <td style={noBottomPadding}>{dateFmt.format(new Date(value.work_date))}</td>
      </tr>
      <tr>
        <td style={noBottomPadding}>เสร็จ : </td>
        <td style={noBottomPadding}>{dateFmt.format(new Date(value.finish_date))}</td>
      </tr>
    </tbody>
  </table>
}

function QuantityTable(props) {
  const { qtyFmt, value } = props;

  return <table className="table table-sm table-borderless" style={{width:'160px'}}>
    <tbody>
      <tr>
        <td style={{width:'60%'}}>ทั้งหมด :</td>
        <td align="right">{value.qty_total ? qtyFmt.format(value.qty_total) : ''}</td>
      </tr>
      <tr>
        <td>NG/เสีย :</td>
        <td align="right">{value.qty_ng ? qtyFmt.format(value.qty_ng) : ''}</td>
      </tr>
      <tr>
        <td>Good/ดี :</td>
        <td align="right">{value.qty_good ? qtyFmt.format(value.qty_good) : ''}</td>
      </tr>
    </tbody>
  </table>
}

const delaySearch = 500;
let timerSearch = null;

function handleSearch(dispatch, page, cond) {
  if (timerSearch) clearTimeout(timerSearch);
  timerSearch = setTimeout(() => {
    dispatch(queryHistoryOrder(cond))
  }, delaySearch);
}

export function WorkHistoryApp(props) {
  const enquiryLayout = useSelector((state) => state.history.enquiryLayout);
  const searchData = useSelector((state) => state.history.searchData);
  const searchFilter = useSelector((state) => state.history.searchData.filter);
  const searchFinish = useSelector((state) => state.history.searchData.finish);

  const dispatch = useDispatch();
  const { page } = useParams();
  const history = useHistory();

  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  const dateFmt = new Intl.DateTimeFormat(props.locale || 'en-UK', options);

  const qtyFmt = new Intl.NumberFormat(props.locale || 'en-UK', {
    maximumFractionDigits: 0
  })

  useEffect(() => {
    if (defaultEnquiryLayout.length > 1) {
      // delete defaultEnquiryLayout[1];
      defaultEnquiryLayout.pop();
    }

    switch (page) {
      case 'product':
        defaultEnquiryLayout.push(foundProductGroup);
        break;

      case 'contact':
        defaultEnquiryLayout.push(foundContactGroup);
        break;
  
      default:
        break;
    }

    loadTemplate(defaultEnquiryLayout, (v) => {
      // console.info(v);
      dispatch(actions.setEnquiryLaout(v));
    });
  }, [dispatch, page]);

  useEffect(() => {
    console.info('Will search...');
    const cond = { filter: searchFilter, finish: searchFinish };
    switch(page) {
      default:
        cond.sub = page;
    }

    handleSearch(dispatch, page, cond);
  }, [dispatch, page, searchFilter, searchFinish])

  const title = () => {
    switch (page) {
      case 'product':
        return 'ประวัติการผลิต ตาม สินค้า';

      case 'contact':
        return 'ประวัติการผลิต ตาม ลูกค้า';
  
      default:
        return 'รายงานประวัติการผลิต'
    }
  }

  const handleFilterChange = useCallback(
    (e) => {
      const _data = { ...searchData };

      _data[e.target.name] = e.target.value;

      dispatch(actions.setSearchData(_data));
    },
    [dispatch, searchData]
  );

  const handleOpen = useCallback(
    (value) => {
      // history.push(`/work-order/${value._id}`);
      window.open(`/work-order/${value._id}`);
    },
    [],
  )

  const _this = {
    // pill_status: (v) => <PillStatus>{v}</PillStatus>
    pill_no: (v) => <Pill color='info'>{v}</Pill>,
    span_work_date: (v) => <DateSpan dateFmt={dateFmt} label="สั่ง :">{v.work_date}</DateSpan>,
    span_finish_date: (v) => <DateSpan dateFmt={dateFmt} label="เสร็จ :">{v.finish_date}</DateSpan>,
    date_table: (v) => <DateTable value={v} dateFmt={dateFmt}></DateTable>,
    qty_table: (v) => <QuantityTable value={v} qtyFmt={qtyFmt}></QuantityTable>,

    handlers: {
      handleOpen
    }
  };

  return (
    <React.Fragment>
      <ZetaSection title={title()} name="search">
        <div className="row">
          {enquiryLayout &&
            enquiryLayout.map((t, i) => {
              return (
                <ZetaGroup
                  key={i}
                  app={_this}
                  em={t}
                  size={t.size}
                  addClass={t.class || ''}
                  template={t.template}
                  data={searchData}
                  onChange={handleFilterChange}
                />
              );
            })}
        </div>
      </ZetaSection>
    </React.Fragment>
  );
}